import { AdminEPDsClient, MoveEPDModel } from '../EpdClient';
const client = new AdminEPDsClient(process.env.REACT_APP_API_URL);

class AdminEpdService {
  static moveEpd = async (epdId: string, toAccountId: string) => {
    const move: MoveEPDModel = { epdId, toAccountId };
    return await client.move(epdId, move);
  };
}

export default AdminEpdService;
